import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getEmbeddedLookerReport: {
        url: `${BASE_PATH_API}/insights/embeddedLookerReportURL/:reportName`,
        method: 'POST'
    },
    getLookerHostName: {
        method: 'GET',
        url: `${BASE_PATH_API}/insights/lookerHostName`
    },
    getDataForRecommendation: {
        method: 'GET',
        url: `${BASE_PATH_API}/insights/recommendations/:reportName`
    },
    accountEligibility: {
        method: 'GET',
        url: `${BASE_PATH_API}/insights/accountEligibility`
    },
    getFilterOptions: {
        url: `${BASE_PATH_API}/insights/reportsCriteriaLookup/:populateFrom`,
        method: 'GET'
    },
    canAccessDashboardPropertyTypes: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/canAccessPropertyTypes`,
        isArray: true
    },
    logInsightsWarning: {
        url: `${BASE_PATH_API}/insights/logInsightsWarning`,
        method: 'POST'
    }
};

export function InsightsApi() {
    return createActions(actions);
}
